import type { JSX, MemoExoticComponent } from 'react'

import { COLOR } from "/app/libraries/arcana/src/vars/index.ts"

import { memo } from 'react'
import LoadingBar from 'react-top-loading-bar'
import { LoaderGate, setLoaderRef } from './model'

// exports memoized component
export const Loader: MemoExoticComponent<typeof Loader_> = memo(Loader_)

// TODO: get rid of 'react-top-loading-bar', looks like it is abandoned
// or make fork of it
// check issues page https://github.com/klendi/react-top-loading-bar/issues
// and PRs page https://github.com/klendi/react-top-loading-bar/pulls

const loaderStyle = {
  background: `var(${COLOR.ACCENT_TERTIARY})`,
}

Loader_.displayName = 'Loader'
function Loader_(): JSX.Element {
  return (
    <>
      <LoadingBar
        style={loaderStyle}
        shadow={false}
        height={4}
        ref={setLoaderRef}
      />
      <LoaderGate />
    </>
  )
}
